import { ParamsGetCardinalInitialData, ParamsGetJWTCreateData } from 'common/interface';
import { ITwoFAServiceGenerateJWTPostData } from './interface';
import { CardinalWindowSizes } from './constants';

export const getCardinalInitialData = ({
  affiliation,
  chargeId,
  serviceAcquirer,
  amount,
  customerInfo,
  referenceId,
  tokenID,
  phoneNumber,
  customerName,
  liveMode,
  entity,
  isMobile,
}: ParamsGetCardinalInitialData) => {
  const merchantName = entity?.name || 'Conekta';
  const { email } = customerInfo;

  const AdditionalParameters = {
    serviceMcc: '5045',
    serviceAcquirerBin: '451899',
    serviceLoginID: affiliation,
    serviceCountryCode: 'MX',
    serviceMerchantName: merchantName,
    serviceMerchantID: affiliation,
    serviceMerchantURL: 'https://conekta.com/',
    serviceRequestorID: `10052155*${affiliation}`,
    serviceRequestorName: 'Conekta',
    serviceMobilePhone: '5569654638',
    serviceProductCode: 'SVC',
    overridePaymentMethod: 'CR',
    serviceAcquirer,
  };

  const cardToValidate = {
    payerAuthValidateServiceRun: 'true',
    merchantReferenceCode: referenceId,
    unitPrice: amount,
    tokenID,
    liveMode,
    authenticationTransactionID: 0,
    additionalParameterModel: AdditionalParameters,
    chargeId,
  };

  const transactionData = {
    merchantReferenceCode: referenceId,
    enrollServiceRun: 'true',
    referenceID: referenceId,
    tokenID,
    price: amount,
    giftCategory: 'false',
    firstName: customerName.toUpperCase(),
    lastName: '',
    street: 'Av. Nuevo León 404, Hipódromo, Cuauhtémoc',
    city: 'CDMX',
    postalCode: '06100',
    state: '',
    country: 'MX',
    email: email,
    phoneNumber: phoneNumber,
    additionalParameterModel: AdditionalParameters,
    windowSize: isMobile ? CardinalWindowSizes.MOBILE : CardinalWindowSizes.DESKTOP,
    liveMode,
    chargeId,
    serviceAcquirer,
  };

  return {
    cardToValidate,
    transactionData,
  };
};

export const parseDataToCreateJWTDto = ({
  amount,
  id,
  name,
  customerName,
  liveMode,
}: ParamsGetJWTCreateData): ITwoFAServiceGenerateJWTPostData => {
  const threeDsReferenceID: string = id;
  return {
    orderDetails: {
      Amount: amount,
      CurrencyCode: 'MX',
      NameOnAccount: customerName,
      OrderChannel: '',
      OrderDescription: name,
      OrderNumber: threeDsReferenceID,
    },
    referenceID: threeDsReferenceID,
    liveMode,
  };
};
